import SearchField from "shared/Search";
import InputSelect from "./InputSelect";
import { TKIconSearch } from "assets/images/svgs";
import { useState } from "react";
import { useSelector } from "react-redux";

const ProjectSearchBar = ({ setResult, donate }) => {
  const { projects } = useSelector((state) => state.project);
  const [isFocused, setIsFocused] = useState(false);
  const [searchString, setSearchString] = useState("");
  const categoryOptions = [
    {
      title: "Category",
      value: "",
    },
    {
      title: "Children",
      value: "children",
    },
    {
      title: "Education",
      value: "education",
    },
    {
      title: "Food Security",
      value: "food_security",
    },
    {
      title: "Health",
      value: "health",
    },
    {
      title: "Mental Health",
      value: "mental_health",
    },
    {
      title: "Physical Health",
      value: "physical_health",
    },
  ];
  const needsOptions = [
    {
      title: "Needs",
      value: "",
    },
    {
      title: "Clothing",
      value: "clothing",
    },
    {
      title: "Dry Food",
      value: "dry_foods",
    },
    {
      title: "Educational",
      value: "educational_materials",
    },
    {
      title: "Furniture",
      value: "furniture",
    },
    {
      title: "Others",
      value: "others",
    },
  ];
  const newestOptions = [
    {
      title: "Newest",
      value: "",
    },
    {
      title: "Closest to Goal",
      value: "closest_to_goal",
    },
    {
      title: "Fund Raised",
      value: "fund_raised",
    },
    {
      title: "Relevance",
      value: "relevance",
    },
  ];

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      setResult(
        projects?.filter(
          (data) =>
            data.name.toLowerCase().includes(searchString.toLowerCase()) ||
            data.status.toLowerCase().includes(searchString.toLowerCase()) ||
            data.summary.toLowerCase().includes(searchString.toLowerCase())
        )
      );
    }
  };

  return (
    <div className="flex justify-center items-center mt-[87px]">
      <div className="flex flex-wrap justify-center items-center gap-4 py-4">
        <SearchField
          className="w-[330px]"
          gradient
          placeholder="Search by keyword"
          onFocus={() => setIsFocused(true)}
          onChange={(e) => setSearchString(e.target.value)}
          onKeyDown={handleKeyPress}
        />
        <div className="flex flex-wrap justify-center items-center gap-4 max-[375px]:gap-1">
          <InputSelect
            name="category"
            divClass="!border-none !w-[150px]"
            options={categoryOptions}
            className="!text-[16px]"
            onChange={(e) => {
              if (e.target.value === "") {
                setResult(projects);
              } else {
                setResult(
                  projects?.filter((x) =>
                    x?.project_category?.find(
                      (category) =>
                        category.toLowerCase() === e.target.value.toLowerCase()
                    )
                  )
                );
              }
            }}
          />
          {!donate && (
            <InputSelect
              name="needs"
              options={needsOptions}
              divClass="!border-none !w-[120px]"
              className="!text-[16px]"
              onChange={(e) => {
                if (e.target.value === "") {
                  setResult(projects);
                } else {
                  setResult(
                    projects?.filter((x) =>
                      x?.needs?.find((need) => need === e.target.value)
                    )
                  );
                }
              }}
            />
          )}
          <div className="w-[210px] flex items-center gap-x-2">
            <p className="whitespace-nowrap">Sort by:</p>
            <InputSelect
              name="newest"
              divClass="!w-[180px] !h-[50px] !border-[#F0CA18]"
              options={newestOptions}
              className="!text-[16px]"
              onChange={(e) => {
                if (e.target.value === "") {
                  setResult(projects);
                } else {
                  setResult(
                    projects?.filter((x) =>
                      x?.newest?.find(
                        (newestOptio) => newestOptio === e.target.value
                      )
                    )
                  );
                }
              }}
            />
          </div>
        </div>
        {isFocused && (
          <button
            type="button"
            onClick={() => {
              setResult(
                projects?.filter(
                  (data) =>
                    data.name
                      .toLowerCase()
                      .includes(searchString.toLowerCase()) ||
                    data.status
                      .toLowerCase()
                      .includes(searchString.toLowerCase()) ||
                    data.summary
                      .toLowerCase()
                      .includes(searchString.toLowerCase())
                )
              );
            }}
            className="h-[45px] cursor-pointer flex gap-2 justify-center items-center rounded-full bg-gradient-to-r  from-[#F0CA18] to-[#F57200] w-[120px]"
          >
            <TKIconSearch className="stroke-white" />
            <p className="text-white">Search</p>
          </button>
        )}
      </div>
    </div>
  );
};

export default ProjectSearchBar;
